<template>
	<div>
		<!-- 开具弹框 -->
		<kgdiag
			@closekgdialog="closekgdialog"
			@radiochange="radiochange"
			@openInvoice="readInvoice"
			:headtitle="kgtitle"
			:kgdialog="kgdialog"
			:tableDatans="tableDatans"
			:tableDatakp="tableDatakp"
		></kgdiag>
		<el-dialog title="发票读入" :visible.sync="writeInvoicePage" height="500px" width="1100px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="writeInvoiceTitle" :isdiag="true"></minhead> -->
			<div style="margin: -10px 0px 10px 10px"><el-button type="primary" plain @click="manualEntryPage = true">手工录入</el-button></div>
			<div class="tableh">
				<el-table :data="lingGouData" border style="width: 100%" :height="400" ref="multipleTable">
					<el-table-column prop="equipmentNumber" label="税盘编号" align="center"></el-table-column>
					<el-table-column prop="faplxdm" label="发票类型" align="center" :formatter="formaterFalxdm"></el-table-column>
					<el-table-column prop="fapdm" label="发票代码" align="center"></el-table-column>
					<el-table-column prop="qishm" label="起始号码" align="center"></el-table-column>
					<el-table-column prop="zhongzhm" label="终止号码" align="center"></el-table-column>
					<el-table-column prop="fapfs" label="发票份数" align="center"></el-table-column>
					<el-table-column fixed="right" label="操作" width="100" align="center">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="writeInvoice(scope.row)">写入</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="buttomanniu"><el-button @click="writeInvoicePage = false">关闭</el-button></div>
		</el-dialog>
		<el-dialog title="发票手工录入" :visible.sync="manualEntryPage" height="600px" width="500px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="manualEntryPageTitle" :isdiag="true"></minhead> -->
			<div style="width: 100%;max-height: 400px; overflow-y: auto;" class="horizontally">
				<div style="width: 100%;" class="horizontally">
					<el-form label-width="100px" class="demo-ruleForm" style="margin-right: 100px;">
						<div class="Centerupdown">
							<el-form-item label="税盘编号:" :label-width="formLabelWidth">
								<el-select v-model="faplr.jqbh" style="width: 215px;">
									<el-option v-for="item in faplr" :key="item.kaipjbh" :label="item.kaipjmc" :value="item.kaipjbh"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="发票类型:" :label-width="formLabelWidth">
								<el-select v-model="faplr.faplxdm" style="width: 215px;">
									<el-option label="电子普票" value="026"></el-option>
									<el-option label="电子专票" value="028"></el-option>
									<el-option label="纸质专票" value="004"></el-option>
									<el-option label="纸质普票" value="007"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="发票代码:" :label-width="formLabelWidth"><el-input v-model="faplr.fapdm" style="width:215px"></el-input></el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="起始号码:" :label-width="formLabelWidth"><el-input v-model="faplr.qishm" style="width:215px"></el-input></el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="终止号码:" :label-width="formLabelWidth"><el-input v-model="faplr.zhongzhm" style="width:215px"></el-input></el-form-item>
						</div>
						<div class="Centerupdown">
							<el-form-item label="发票份数:" :label-width="formLabelWidth"><el-input v-model="faplr.fapfs" style="width:215px"></el-input></el-form-item>
						</div>
					</el-form>
				</div>
			</div>
			<div class="buttomanniu">
				<el-button type="primary" plain @click="saveManualEntry">确认录入</el-button>
				<el-button @click="manualEntryPage = false">关闭</el-button>
			</div>
		</el-dialog>
		<el-dialog title="设置阈值" :visible.sync="yudiag" width="600px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="yutitle" :isdiag="true"></minhead> -->
			<div style="margin-top: 30px;" class="Verticalcenter-inline">
				<el-form ref="ruleForm" label-width="200px" class="demo-ruleForm">
					<el-form-item label="开票点"><el-input type="text" v-model="updateForm.kaipzddm" style="width: 215px;" disabled="true"></el-input></el-form-item>
					<el-form-item label="发票类型">
						<el-select style="width: 215px;" v-model="updateForm.faplxdm" disabled="true">
							<el-option label="电子普票" value="026"></el-option>
							<el-option label="电子专票" value="028"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="阈值"><el-input-number type="text" :min="0" v-model="updateForm.baojfz" style="width: 215px;"></el-input-number></el-form-item>
				</el-form>
			</div>
			<div class="buttomanniu">
				<el-button type="primary" @click="saveUpdate()">保存</el-button>
				<el-button @click="yudiag = false">关闭</el-button>
			</div>
		</el-dialog>
		<div class="areacontent">
			<taxSearch :searchdata="searchalllist" :searchlist="searchlist" labelwidth="150px" labelPosition="left" @submitSearch="getDistributeAlarmList()"></taxSearch>
			<div class="headline">
			</div>
			<div class="Centerupdown">
				<!-- <el-button type="primary" plain @click="forkaiju()" style="width: 100px;">发票读入</el-button> -->
				<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="forkaiju()"><samp>发票读入</samp></div>

				<!-- <el-button type="primary" plain @click="getDistributeAlarmList()" style="width: 100px;">查询</el-button> -->
				<!-- 	<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="getDistributeAlarmList()" >
						<samp>
						查询
						</samp>
					</div> -->
				<!-- <el-button type="primary" plain @click="resetForm()" style="width: 100px;">重置</el-button> -->
				<!-- <div class="addstyle" style="width: 110px; margin-right: 10px;" @click="resetForm()" >
						<samp>
						重置
						</samp>
					</div> -->
				<!--  <el-button type="primary" plain style="width: 100px;margin-right: 10px;" @click="excelExport" >
                        导出列表
                        <i class="el-icon-thumb el-icon--right"></i>
                    </el-button> -->
				<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="excelExport()">
					<samp>
						导出列表
						<i class="el-icon-thumb el-icon--right"></i>
					</samp>
				</div>
			</div>
			<div class="areatable">
				<div class="tableh">
					<el-table :data="tableData" border style="width: 100%" height="calc(100vh - 352px )" ref="multipleTable">
						<el-table-column prop="equipmentNumber" label="税盘编号" align="center" min-width="100"></el-table-column>
						<el-table-column prop="faplxdm" label="发票类型" align="center" min-width="100" :formatter="formaterFalxdm"></el-table-column>
						<el-table-column prop="fapdm" label="发票代码" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="qishm" label="起始号码" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="zhongzhm" label="终止号码" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
						<el-table-column prop="fapfs" label="发票份数" align="center" min-width="100"></el-table-column>
						<el-table-column prop="shengyfs" label="剩余份数" align="center"></el-table-column>
						<el-table-column prop="linggrq" label="领购日期" align="left" min-width="160px" show-overflow-tooltip>
							<template slot-scope="scope">
								<span v-if="scope.row.linggrq">{{ timestampToStr(scope.row.linggrq, 'yyyy年MM月dd日') }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="baojfz" label="阈值" align="center" min-width="100">
							<template slot-scope="scope">
								<span v-if="scope.row.shengyfs != '0'">{{ scope.row.baojfz }}</span>
							</template>
						</el-table-column>
						<el-table-column label="是否报警" align="center" min-width="100">
							<template slot-scope="scope">
								<span v-if="scope.row.shengyfs != '0'">
									<span :style="scope.row.shifbj == '1' ? 'color:#3C6EF5' : 'color:#D2D2D2'">{{ scope.row.shifbj == '1' ? '是' : '否' }}</span>
									<el-switch style="margin-left: 10px;" v-model="scope.row.shifbj == '1'" active-color="#3C6EF5" inactive-color="#D2D2D2"></el-switch>
								</span>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" align="center" min-width="100">
							<template slot-scope="scope">
								<span v-if="scope.row.shengyfs != '0'"><el-button type="text" size="small" @click="foraddyu(scope.row)">设置阈值</el-button></span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="buttompage">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]"
						:page-size="pagenum"
						:key="elementui_page_component_key"
						:current-page="currentpage"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import { Loading } from 'element-ui';
export default {
	components: {},
	data() {
		return {
			searchlist: [
				{
					prop: 'linggrq_year',
					label: '领购年份',
					type: 'select',
					selectval: this.getYears()
				},
				{
					prop: 'linggrq_month',
					label: '领购月份',
					type: 'select',
					selectval: this.getMonths()
				},
				{
					prop: 'faplxdm',
					label: '发票种类',
					type: 'select',
					selectval: [
						{
							label: '电子普票',
							value: '026'
						},
						{
							label: '纸质普票',
							value: '007'
						},
						{
							label: '电子专票',
							value: '028'
						},
						{
							label: '纸质专票',
							value: '004'
						},
						{
							label: '全部',
							value: ''
						}
					]
				}
			],
			yudiag: false,
			writeInvoicePage: false,
			// 手工录入相关
			manualEntryPage: false,
			/* 开具弹框 */
			page: 1,
			pagenum: 10,
			totalcount: 10,
			tableData: [],
			lingGouData: [],
			headtitle: ['库存管理', '发票库存查询'],
			manualEntryPageTitle: ['发票手工录入'],
			yutitle: ['设置阈值'],
			writeInvoiceTitle: ['发票读入'],
			serchval: '',
			updateForm: {},
			tableHeight: '',
			currentpage: 1,
			elementui_page_component_key: '',
			searchalllist: {
				linggrq_year: '',
				linggrq_month: '',
				faplxdm: '',
				listlikeSearch: ''
			},
			fpxlxoptions: [
				{
					label: '电子普票',
					value: '026'
				},
				{
					label: '纸质普票',
					value: '007'
				},
				{
					label: '电子专票',
					value: '028'
				},
				{
					label: '纸质专票',
					value: '004'
				},
				{
					label: '全部',
					value: ''
				}
			],
			years: this.getYears(),
			months: this.getMonths(),
			checkmeauList: ['发票类型', '发票代码', '起始号码', '终止号码', '发票份数', '剩余份数', '领购日期'],
			checkHeadFiled: ['faplxdm', 'fapdm', 'qishm', 'zhongzhm', 'fapfs', 'shengyfs', 'linggrq'],
			currCompany: {},
			// 开票机信息 // 手工录入相关
			formLabelWidth: '150px',
			faplr: {
				jqbh: '',
				faplxdm: '',
				fapdm: '',
				qishm: '',
				zhongzhm: '',
				fapfs: ''
			},
			defaultkpj: '',
			/* 开具弹框 */
			kgdialog: false,
			kgtitle: ['选择开票机'],
			tableDatans: [{}],
			tableDatakp: [{}],
			selectKaipj: ''
		};
	},
	created() {
		this.loadKpjList();
		this.getCurrCompanyData();
		this.getDistributeAlarmList();
	},
	mounted() {
		this.repairtable();
	},
	methods: {
		repairtable() {
			this.$nextTick(() => {
				this.tableHeight = this.diagheightzhengshutiankai();
				setTimeout(() => {
					this.$refs.multipleTable.doLayout();
				}, 300);
				window.onresize = () => {
					this.tableHeight = this.diagheightzhengshutiankai();
					setTimeout(() => {
						this.$refs.multipleTable.doLayout();
					}, 300);
				};
			});
		},
		forserch() {
			this.currentpage = 1;
			this.elementui_page_component_key++;
			this.page = 1;
			this.getDistributeAlarmList();
		},
		// 获取开票机  手工录入相关
		loadKpjList() {
			this.$https.fetchPost('doc/getKaipjList').then(res => {
				if (res.data.success) {
					this.faplr = JSON.parse(res.data.obj);
					this.faplr.forEach(item => {
						if (item.queskpj == '1') {
							this.faplr.jqbh = item.kaipjbh;
							this.defaultkpj = item.kaipjbh;
							return;
						}
					});
				}
			});
		},
		// 提交手工录入结果 手工录入相关
		saveManualEntry() {
			let that = this;
			// 数据类型
			let data = {
				jqbh: this.faplr.jqbh,
				faplxdm: this.faplr.faplxdm,
				// "fapdm": this.faplr.fapdm, "qishm": this.faplr.qishm,
				// "zhongzhm": this.faplr.zhongzhm,
				fapfs: this.faplr.fapfs
			};
			// 做校验用的
			let title = { jqbh: '税盘编号', faplxdm: '发票类型', fapdm: '发票代码', qishm: '起始号码', zhongzhm: '终止号码', fapfs: '发票分数' };
			for (let key in data) {
				if (!data[key]) {
					this.$message.error(title[key] + '不能为空');
					return false;
				}
			}
			let rowData = JSON.stringify(data);
			this.$https.fetchPost('/inventory/downloadInvoice', rowData).then(res => {
				if (res.success) {
					that.$message.success('录入成功');
					that.manualEntryPage = false;
					this.getDistributeAlarmList();
				}
			});
		},
		foraddyu(row) {
			this.updateForm = row;
			this.yudiag = true;
		},
		handleSizeChange(val) {
			this.pagenum = val;
			this.getDistributeAlarmList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getDistributeAlarmList();
		},
		getDistributeAlarmList() {
			this.$https.fetchPost('inventory/syncDistribute').then(res => {});
			var newform = JSON.parse(JSON.stringify(this.searchalllist));
			let params = {
				likeSearch: this.serchval,
				page: this.page,
				limit: this.pagenum,
				order: 'dd.linggrq',
				sort: 'desc',
				search: newform
			};
			this.$https.fetchPost('/inventory/getDocDistributeList', params).then(res => {
				console.log(res);
				if (this.tableData.length > 0) {
					this.tableData = {};
					this.totalcount = '';
				}
				this.tableData = res.data.data;
				this.totalcount = res.data.count;
			});
		},
		readInvoice() {
			if (this.selectKaipj === '') {
				this.$message({
					type: 'error',
					message: this.$tolertJSON['005-2']
				});
				return;
			}
			this.kgdialog = false;
			this.$https.fetchPost('/inventory/getCurWanglgpxx', this.selectKaipj).then(res => {
				this.writeInvoicePage = true;
				if (res.data.success) {
					this.lingGouData = res.data.obj;
				}
			});
		},
		/* 开具弹框 */
		forkaiju() {
			this.$https.fetchPost('/doc/getKaipjList').then(res => {
				console.log(JSON.parse(res.data.obj));
				this.tableDatakp = JSON.parse(res.data.obj);
				this.kgdialog = true;
			});
		},
		/* 子传父 */
		closekgdialog(e) {
			this.kgdialog = e;
		},
		radiochange(val) {
			this.selectKaipj = val.kaipjbh;
		},
		writeInvoice(row) {
			row = Object.assign({}, { jqbh: this.selectKaipj }, row);
			this.$https.fetchPost('/inventory/downloadInvoice', row).then(res => {
				this.getDistributeAlarmList();
			});
		},
		saveUpdate() {
			this.$https.fetchPost('/inventory/updateDistributeAlarm', this.updateForm).then(res => {
				if (res.data.success) {
					this.getDistributeAlarmList();
					this.yudiag = false;
				}
			});
		},
		formaterFalxdm(row) {
			let result = row.faplxdm;
			switch (row.faplxdm) {
				case '026':
					result = '电子普票';
					break;
				case '028':
					result = '电子专票';
					break;
				case '004':
					result = '纸质专票';
					break;
				case '007':
					result = '纸质普票';
					break;
			}
			return result;
		},
		getYears() {
			let date = new Date();
			let currentYear = date.getFullYear();
			let yearOptions = [];
			for (let year = currentYear; year > currentYear - 10; year--) {
				yearOptions.push({
					label: year + '年',
					value: year + ''
				});
			}
			yearOptions.push({
				label: '全部',
				value: ''
			});
			return yearOptions;
		},
		getMonths() {
			return [
				{
					label: '1月',
					value: '1'
				},
				{
					label: '2月',
					value: '2'
				},
				{
					label: '3月',
					value: '3'
				},
				{
					label: '4月',
					value: '4'
				},
				{
					label: '5月',
					value: '5'
				},
				{
					label: '6月',
					value: '6'
				},
				{
					label: '7月',
					value: '7'
				},
				{
					label: '8月',
					value: '8'
				},
				{
					label: '9月',
					value: '9'
				},
				{
					label: '10月',
					value: '10'
				},
				{
					label: '11月',
					value: '11'
				},
				{
					label: '12月',
					value: '12'
				},
				{
					label: '全部',
					value: ''
				}
			];
		},
		resetForm() {
			Object.keys(this.searchalllist).map(key => (this.searchalllist[key] = ''));
		},
		excelExport() {
			let url = this.$https.baseURL + 'excel/getDocDistributeExcel'; //请求下载文件的地址
			let token = localStorage.getItem('token');
			let param = JSON.parse(JSON.stringify(this.searchalllist));
			param.headTitle = this.checkmeauList;
			param.headFiled = this.checkHeadFiled.toString();
			if ((token != '') & (token != null)) {
				axios.defaults.headers.common['token'] = token;
			}
			axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
			axios
				.post(url, param, { responseType: 'blob' })
				.then(res => {
					if (!res) return;
					let blob = new Blob([res.data], {
						type: 'blob'
					});
					let url = window.URL.createObjectURL(blob);
					let aLink = document.createElement('a');
					aLink.style.display = 'none';
					aLink.href = url;
					aLink.setAttribute('download', '红冲发票.xls'); // 下载的文件
					document.body.appendChild(aLink);
					aLink.click();
					document.body.removeChild(aLink);
					window.URL.revokeObjectURL(url);
					// let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
					// let objectUrl = URL.createObjectURL(blob);
					// window.location.href = objectUrl;
				})
				.catch(error => {
					this.$message.error(error);
				});
		},
		getCurrCompanyData() {
			var obj = JSON.parse(localStorage.getItem('useropj'));
			this.currCompany = obj.currCompany;
		}
	}
};
</script>

<style scoped="scoped" lang="less">
// /deep/.el-dialog__body {
// 	padding: 0;
// }
/deep/.el-table--small td {
	padding: 4px 0;
}
/deep/.el-table__body-wrapper {
	min-height: 160px;
}

.topspan > span {
	font-size: 17px;
	color: #0080ff;
}
.areatable {
	margin-top: 27px;
}
.areacontent {
	margin-left: 21px;
}
</style>
